import React, { Fragment, useEffect, useState } from 'react'
import { Asn } from '../../../interfaces/Asn/Asn'
import { Grid, Typography } from '@mui/material'
import { useApi } from '../../../hooks/useApi'
import { Status } from '../../../hooks/useFetchState'
import { Loading } from '../../UI/Loading/Loading'
import { formatNonUTCDate, utcToLocal } from '../../../utils/dateHelper'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'

interface AsnSummaryProps {
  elementId: number
}

export const getAsnState = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/${asnId}`)
  return axios.get(url.toString())
}

export const AsnSummary: React.FC<AsnSummaryProps> = ({ elementId }) => {
  const [loading, setLoading] = useState<boolean>(false)
  const { state, callApi } = useApi<Asn>()

  const requestGetASN = () => {
    setLoading(true)
    callApi(getAsnState(elementId))
      .then(() => {
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
      })
    setLoading(false)
  }

  useEffect(() => {
    requestGetASN()
  }, [])
  if (state.status === Status.Loading || loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Fragment>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Almacén:</b>
            {` ${state.data?.warehouseName}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Tipo de Documento:</b>
            {` ${state.data?.typeAsnDocumentName}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Creación: </b>
            {utcToLocal(state.data?.createdDate, 'dd-MM-yyyy')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Proveedor:</b>
            {` ${state.data?.supplierName}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Tipo de Ingreso:</b>
            {` ${state.data?.typeAsnIncomeName}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Fecha estimada recepción: </b>
            {formatNonUTCDate(state.data?.estimatedDate)}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Origen:</b>
            {` ${state.data?.supplierOriginName}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Bultos:</b>
            {` ${state.data?.packagesQty}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Fecha de recepción: </b>
            {utcToLocal(state.data?.receivedDate, 'dd-MM-yyyy')}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Tipo de ASN:</b>
            {` ${state.data?.typeAsnSourceName}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>SKUs:</b>
            {` ${state.data?.skuQuantity}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Typography variant='body2' component='p'>
            <b>Cantidad de Unidades:</b>
            {` ${state.data?.realQty}`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Typography variant='body2' component='p'>
            <b>Tracking Number:</b>
            {` ${state.data?.trackingNumber || ''}`}
          </Typography>
        </Grid>
      </Fragment>
    )
  }
}
